"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressDisplayField = void 0;
var core_ui_1 = require("@newfront-insurance/core-ui");
var react_1 = __importDefault(require("react"));
var shared_styled_components_1 = require("../../components/shared-styled-components");
function AddressDisplayField(_a) {
    var address = _a.address, _b = _a.width, width = _b === void 0 ? 400 : _b, _c = _a.color, color = _c === void 0 ? 'primary' : _c;
    return (react_1.default.createElement(shared_styled_components_1.StyledAddressFieldWrapper, { style: { width: width } },
        react_1.default.createElement(shared_styled_components_1.StyledAddressField, { cursor: "default" },
            react_1.default.createElement(core_ui_1.Text, { color: (address === null || address === void 0 ? void 0 : address.formattedAddress) ? color : core_ui_1.colors.steel[300] }, (address === null || address === void 0 ? void 0 : address.formattedAddress) || 'No address'))));
}
exports.AddressDisplayField = AddressDisplayField;
